import React from "react";

export default function Footer () {
    return (
        <footer>
            <a href="https://github.com/busraileri/meme-generator.git" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-github"></i>
            </a>
        </footer>
    

    )
}